import { render, staticRenderFns } from "./SortCBCTable.vue?vue&type=template&id=49b0da01"
import script from "./SortCBCTable.vue?vue&type=script&lang=js"
export * from "./SortCBCTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports